/**
 * Director helper utilities
 * Provides functions for filtering and finding director information
 */

import { ShareholderDirector } from "../../../features/merchant/rep";

/**
 * Extract valid email addresses from shareholders/directors
 * Filters out empty or whitespace-only emails
 * Used multiple times to avoid duplicating the map + filter logic
 */
export const getDirectorEmails = (
  shareholdersDirectors: ShareholderDirector[]
): string[] => {
  return shareholdersDirectors
    .map((user) => user?.email)
    .filter((email) => email && email.trim() !== "");
};

/**
 * Find director by email address
 * Encapsulates the common pattern of finding a director by their email
 */
export const findDirectorByEmail = (
  shareholdersDirectors: ShareholderDirector[],
  email: string
): ShareholderDirector | undefined => {
  return shareholdersDirectors.find((user) => user.email === email);
};
